import { useWeb3ReactPlus } from '../Web3ReactPlus/Web3ReactPlusProvider'
import { useAppStateReducer } from '../AppState'

export function useSaffronStakingProtocolInfo(): Record<string, any> {
  const { chainId } = useWeb3ReactPlus()
  const [appState] = useAppStateReducer()
  if (!chainId) return {}
  return appState[chainId]?.api['protocol-info']?.data?.stakingInfo ?? {}
}
